import { env } from 'configs/EnvironmentConfig';

export const API_BASE_URL = env.API_ENDPOINT_URL
export const API_EXTRA_PATH = '/api/v1'
export const API_FULL_URL = API_BASE_URL + API_EXTRA_PATH

// ELOGO Payment API Credentials
export const ELOGO_APIKEY = 'cf43cd2b-7d2e-401b-9738-0c3819adf6de'
export const ELOGO_SECRETKEY = '8fc30c60-65d1-456f-b263-a8979cc9d864'

